import { Component, ElementRef, HostListener, ViewChild, ViewChildren, QueryList, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { CommonModule, DecimalPipe, Location } from '@angular/common';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-preview-payrol',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './preview-payrol.component.html',
  styleUrls: ['./preview-payrol.component.css'],
  providers: [DecimalPipe]
})
export class PreviewPayrolComponent implements OnInit {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('payrollContent') payrollContent!: ElementRef;
  @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;
  @ViewChild('payrollContenttable') payrollContenttable!: ElementRef;
  @ViewChildren('payrollContenttable') payrollContenttables!: QueryList<ElementRef>;
  @ViewChild('payrollTotals') payrollTotals!: ElementRef;

  

  showSpinner = false;
  usersList: any[] = [];
  month_char = '';
  month_year = 0;
  month_int = 0;
  totals: any;
  showSkeleton = true;
  dropdownOpen = false;
  selectedAdmins: any[] = [];
  selectedAdminNames = '';
  sectionUsersMap: Record<string, any[]> = {};
  // Define sections
  sections = [
    { title: 'Bank Payroll', type: 'bank_transfer', cols: [5, 4, 3], showAccount: true, color: 'purple-color-head', circle: 'blue-circle' },
    { title: 'Other Payments', type: 'other', cols: [9, 3], showAccount: false, color: 'orange-color-head', circle: 'orange-circle' },
    { title: 'Cash Payments', type: 'cash', cols: [9, 3], showAccount: false, color: 'cash-color-head', circle: 'cash-circle' },
    { title: 'Advanced Salary Payments', type: 'advance_payment', cols: [9, 3], showAccount: false, color: 'advance-color-head', circle: 'advance-circle' },
    { title: 'Final Settlements', type: 'final', cols: [9, 3], showAccount: false, color: 'Final-color-head', circle: 'Final-circle' }
  ];
  admins: any[] = [];
  public selected_date: any = [];
  public totalSalary: any = [];
  public total_shourtHours: any = [];
  public total_lateCheckin: any = [];
  public total_unpaidLeaves: any = [];
  public total__absents: any = [];
  public total_Advance: any = [];
  public total_Overtime: any = [];
  public total_tax: any = [];
  public loan_amount: any = [];
  public total_otherDeduction: any = [];
  public total_Compensation: any = [];
  public totalDeduction: any = [];
  public totalReleasedSalary: any = [];

  public status = '';
  total_absents_count: any = [];
  total_lateCheckin_count: any = [];
  total_shourtHours_count: any = [];
  total_unpaidLeaves_count: any = [];
  selectionMode: any
  check_review: any;
  changeRequestText: any
  salary_total_id: any;
  existPayrollreview: any;
  exist_status: any;
  enableSubmit = false;
  isApprove = false;
  Ischanges = false;
  changeReason: any;
  constructor(
    public payrollService: PayrollService,
    private router: Router,
    public decimalPipe: DecimalPipe,
    private location: Location,
    public dashboardService: DashboardService,
     private route: ActivatedRoute


  ) { }

  ngOnInit() {
    const state = history.state;
      const params = this.route.snapshot.queryParams;

debugger
      if (state && state?.usersList) {
      this.showSkeleton = false;

      this.usersList = state.usersList || [];
      this.month_char = state.month_char;
      this.month_year = state.month_year;
      this.month_int = state.month_int;
      this.totals = state.totals;
      this.check_review = state.check_review;
      this.salary_total_id = state.salary_id
      this.getReviewCheck(this.salary_total_id);
      this.getdetailMonthPayroll();

      if ((this.totals?.totalDeduction == 0) && (this.totals?.totalSalary == 0)) {
        this.showSkeleton = true;

        Swal.fire({
          iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
          title: 'Kindly First Generate Payroll To preview',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          // navigate back after alert
          this.location.back();
        });
      }

    }
    else {
       Swal.fire({
          iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
          title: 'Something Went Wrong Kinldy Try Again Later',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          // navigate back after alert
          this.location.back();
        });

    }

    this.getAllAdmins();
    this.sections.forEach(section => {
      this.sectionUsersMap[section.type] = this.getUsersForSectionNoSideEffect(section);
    });
    // Calculate totals after building the section user map
    this.calculateTotals();
  }

  /**
   * Returns the list of users pre‑computed for the given section type.
   * Previously the template filtered the raw `usersList`; now we can
   * rely on `sectionUsersMap` which already handles partial payments
   * and computes `display_amount` without mutating the original objects.
   */
  getUsersByType(type: string) {
    return this.sectionUsersMap[type] || [];
  }

  getTotal(users: any[], sectionType: string) {
    return users.reduce((acc: number, u: any) => {

      if (sectionType === 'advance_payment') {
        return acc + Number(u.user_salary?.[0]?.advance_payment || 0);
      }

      // use the pre‑computed display_amount when available, fallback to
      // released_salary for backward compatibility
      const amt = u.user_salary?.[0]?.display_amount;
      if (amt != null) {
        return acc + Number(amt);
      }

      return acc + Number(u.user_salary?.[0]?.released_salary || 0);

    }, 0);
  }

  getSectionUsers(type: string) {
    return this.sectionUsersMap?.[type] || [];
  }

  getColSum(section: { cols: number[] }): number {
    return section.cols
      .slice(0, section.cols.length - 1)
      .reduce((acc: number, val: number) => acc + val, 0);
  }

  downloadPDF() {
    this.showSkeleton = true;

    const element = this.payrollContent.nativeElement;

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Canvas dimensions
      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth;
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Add more pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(`Payroll-${this.month_char}-${this.month_year}.pdf`);
      this.showSkeleton = false;
    });
  }

  getAllAdmins() {
    this.payrollService.getAllAdmins().then((value: any) => {
      if (value.success) {
        this.admins = value.data;
      }
    });
  }

  selectAdmin(admin: any) {
    
    const index = this.selectedAdmins.findIndex(a => a.id === admin.id);

    if (index > -1) {
      // Remove admin if already selected
      this.selectedAdmins.splice(index, 1);
    } else {
      // Add admin if not selected
      this.selectedAdmins.push(admin);
    }

    // Update display text
    this.selectedAdminNames = this.selectedAdmins
      .map(a => `${a.first_name} ${a.last_name}`)
      .join(', ');
    console.log('Selected Admins:', this.selectedAdmins);
    console.log('Selected Admin Names:', this.selectedAdminNames);
  }

  // Returns true if the admin is selected
  isAdminSelected(adminId: number): boolean {
    if (!this.selectedAdmins) return false;
    return this.selectedAdmins.some(a => a.id === adminId);
  }

  goBack() {
    this.location.back();
  }

  sendReviewRequest() {
    
    if (!this.selectedAdmins || this.selectedAdmins.length === 0) {
      ($('#comformModal') as any).modal('hide');
      Swal.fire({
        iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Please select at least one admin',
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }
    this.showSkeleton = true;
    ($('#comformModal') as any).modal('hide');

    // Extract all admin IDs
    const adminIds = this.selectedAdmins.map(a => a.id);
    const payload = {
      month_int: this.month_int,
      month_year: this.month_year,
      admin_ids: adminIds
    };

    this.payrollService.sendMailAdmin(payload).then((value: any) => {
      this.showSkeleton = false;
      this.selectedAdminNames = '';
      this.selectedAdmins = [];
      if (value?.success) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Review request sent successfully!',
          showConfirmButton: false,
          timer: 2000
        });

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to sed Mail',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  }

  get showAdvancePaymentSection(): boolean {
    return this.usersList.some(u => {
      const advance = u.user_salary?.[0]?.advance_payment;
      return advance != null && Number(advance) > 0;
    });
  }

  assignedUserIds = new Set<number>();

  getUsersForSection(section: { type: string }) {
    let users: any[] = [];

    if (section.type === 'advance_payment') {
      // Users with advance_payment not null
      users = this.usersList.filter(u =>
        u.user_salary?.[0]?.advance_payment != null &&
        !this.assignedUserIds.has(u.id)
      );
    } else {
      // Other types, but skip already assigned users
      users = this.usersList.filter(u => {
        const salary = u.user_salary?.[0];
        if (!salary) return false;

        // include partial bank-transfer users in both bank and cash
        if (
          section.type === 'bank_transfer' &&
          salary.payment_status === 'partial' &&
          salary.payment_type === 'bank_transfer' &&
          Number(salary.remaining_amount || 0) > 0
        ) {
          return !this.assignedUserIds.has(u.id);
        }
        if (
          section.type === 'cash' &&
          salary.payment_status === 'partial' &&
          salary.payment_type === 'bank_transfer' &&
          Number(salary.remaining_amount || 0) > 0
        ) {
          return !this.assignedUserIds.has(u.id);
        }

        return (
          salary.payment_type === section.type &&
          !this.assignedUserIds.has(u.id)
        );
      });
    }

    // Mark these users as assigned
    users.forEach(u => this.assignedUserIds.add(u.id));

    return users;
  }

  getUsersForSectionNoSideEffect(section: { type: string }) {

    return this.usersList
      .map(u => {
        const salary = u.user_salary?.[0];
        if (!salary) return null;

        const totalSalary = Number(salary.released_salary || 0);
        const bankAmount = Number(salary.partial_transfer_amount || 0);
        const remaining = totalSalary - bankAmount;

        // helper to clone the user with a fresh salary object so we
        // don't mutate the original list item
        const cloneWithAmount = (amt: number) => {
          const copy: any = {
            ...u,
            user_salary: [{ ...salary }]
          };
          copy.user_salary[0].display_amount = amt;
          return copy;
        };

        // ADVANCE PAYMENT SECTION
        if (section.type === 'advance_payment') {
          const advancePayment = Number(salary.advance_payment || 0);
          if (advancePayment > 0) {
            return cloneWithAmount(advancePayment);
          }
        }

        // BANK SECTION
        if (section.type === 'bank_transfer') {
          // partial bank transfer → show already‑paid portion
          if (
            salary.payment_status === 'partial' &&
            salary.payment_type === 'bank_transfer' &&
            Number(salary.remaining_amount || 0) > 0
          ) {
            const rem = Number(salary.remaining_amount || 0);
            return cloneWithAmount(totalSalary - rem);
          }

          if (bankAmount > 0) {
            return cloneWithAmount(bankAmount);
          }

          if (salary.payment_type === 'bank_transfer') {
            return cloneWithAmount(totalSalary);
          }
        }

        // OTHER PAYMENT SECTION
        if (section.type === 'other') {
          if (bankAmount > 0 && remaining > 0) {
            return cloneWithAmount(remaining);
          }

          if (salary.payment_type === 'other') {
            return cloneWithAmount(totalSalary);
          }
        }

        // CASH SECTION: include partial‑bank users plus normal cash
        if (section.type === 'cash') {
          if (
            salary.payment_status === 'partial' &&
            salary.payment_type === 'bank_transfer' &&
            Number(salary.remaining_amount || 0) > 0
          ) {
            return cloneWithAmount(Number(salary.remaining_amount || 0));
          }
          if (salary.payment_type === 'cash') {
            return cloneWithAmount(totalSalary);
          }
        }

        // NORMAL CASES
        if (salary.payment_type === section.type) {
          return cloneWithAmount(totalSalary);
        }

        return null;
      })
      .filter(u => u !== null) as any[];
  }

  cancelReviewRequest() {
    ($('#comformModal') as any).modal('hide');
    this.selectedAdminNames = '';
    this.selectedAdmins = [];
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.dropdownWrapper.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  cancelchangereview() {
    ($('#requestChange') as any).modal('hide');
  }

  sendChangeRequest() {
    
    ($('#requestChange') as any).modal('hide');
    this.showSkeleton = true;
    const reason = this.changeRequestText
    const id = this.salary_total_id

    this.payrollService.sendReviewChange(id, reason).then((value: any) => {
      // this.showSkeleton = false;
      if (value?.success) {
        Swal.fire({
          iconHtml: '<img src="../../assets/images/success-modal" alt="image">',
          title: 'Review change sent successfully!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          // Navigate after modal closes
          this.router.navigate(['/payroll-summary']);
        });

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to changes',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  }

  approvedPayroll() {
    
    ($('#approvedModal') as any).modal('hide');
    this.showSkeleton = true;
    const id = this.salary_total_id

    this.payrollService.approvePayroll(id).then((value: any) => {
      // this.showSkeleton = false;
      this.selectedAdminNames = '';
      this.selectedAdmins = [];
      if (value?.success) {
        Swal.fire({
          iconHtml: '<img src="../../assets/images/success-modal" alt="image">',
          title: 'Review Approved successfully!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          // Navigate after modal closes
          this.router.navigate(['/payroll-summary']);
        });

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Failed to changes',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  }

  getReviewCheck(id: any) {
    
    this.payrollService.checkReview(id)
      .then((value: any) => {
        

        if (value.success) {
          
          this.existPayrollreview = value?.exists;

        }
      });
  }

  checkMonthlyReview() {

  }

  getdetailMonthPayroll() {
    
    this.showSkeleton = true;
    const id = this.salary_total_id
    this.payrollService.getdetailPayrollMonth(id)
      .then((value: any) => {
        if (value.success) {
          
          const data = value?.data;
          this.salary_total_id = data?.id
          this.exist_status = data?.status
          if(this.exist_status === 'change_required'){
            this.Ischanges = true;
            this.changeReason = data?.reason  
          }
          if (this.exist_status === 'draft' || this.exist_status === 'change_required' || this.exist_status == '' || this.exist_status == undefined) {
            this.enableSubmit = true;
            

          } else if(this.exist_status === 'released'){
              this.isApprove = true;
          }else {
            this.enableSubmit = false;

          }
          this.showSkeleton = false;
        }
      });
  }

  sectionTotals: any = {};

  calculateTotals() {
    if (!this.sections) return;

    this.sections.forEach(section => {
      const users = this.sectionUsersMap?.[section.type] || [];
      this.sectionTotals[section.type] = this.getTotal(users, section.type);
    });

    // ensure net salary reflects the sum of released_salary for each record
    const releaseSum = this.usersList.reduce((acc: number, u: any) => {
      return acc + Number(u.user_salary?.[0]?.released_salary || 0);
    }, 0);

    // update totals object so the template can still reference totals.totalReleasedSalary
    this.totals = { ...this.totals, totalReleasedSalary: releaseSum };
  }

  private buildPrintTableContent(maxRowsPerPage = 12): string {
    const chunks = <T>(items: T[], size: number): T[][] => {
      const result: T[][] = [];
      for (let i = 0; i < items.length; i += size) {
        result.push(items.slice(i, i + size));
      }
      return result;
    };

    let html = '';

    const printableSections = this.sections.filter((section) => section.type === 'bank_transfer');

    printableSections.forEach((section) => {
      const users = this.getUsersByType(section.type);
      if (!users.length) {
        return;
      }

      const userChunks = chunks(users, maxRowsPerPage);

      userChunks.forEach((usersChunk: any[], chunkIndex: number) => {
        html += `
          <div class="print-section">
            <div class="table-head ${section.color}">
              <h1>${section.title}</h1>
            </div>
            <div class="custom-table-head">
              <div class="row">
                <div class="col-${section.cols[0]} customertable-head-h1">
                  <h1>Name</h1>
                </div>
                ${section.showAccount ? `
                <div class="col-${section.cols[1]} customertable-head-h1">
                  <h1>Account Number</h1>
                </div>` : ''}
                <div class="col-${section.cols[section.cols.length - 1]} customertable-head-h1">
                  <h1>Amount in Pkr</h1>
                </div>
        `;

        usersChunk.forEach((user: any) => {
          const amount = this.payrollService.showValues
            ? (user.user_salary?.[0]?.display_amount || 0)
            : '****';

          html += `
                <div class="col-${section.cols[0]} customertable-body-p">
                  <p>${user.first_name || ''} ${user.last_name || ''}</p>
                </div>
                ${section.showAccount ? `
                <div class="col-${section.cols[1]} customertable-body-p">
                  <p>${user.ac_number || ''}</p>
                </div>` : ''}
                <div class="col-${section.cols[section.cols.length - 1]} customertable-body-p">
                  <p>${amount}</p>
                </div>
          `;
        });

        if (chunkIndex === userChunks.length - 1) {
          const sectionTotal = this.payrollService.showValues
            ? `${this.sectionTotals?.[section.type] || 0}/-`
            : '****';

          html += `
                <div class="col-${this.getColSum(section)} customertable-footer footer-head-center">
                  <p>Total Amount:</p>
                </div>
                <div class="col-${section.cols[section.cols.length - 1]} customertable-footer">
                  <h1>${sectionTotal}</h1>
                </div>
          `;
        }

        html += `
              </div>
            </div>
          </div>
        `;

        if (chunkIndex < userChunks.length - 1) {
          html += '<div class="print-page-break"></div>';
        }
      });
    });

    return html;
  }


printPayroll() {
  const monthYear = `${this.month_char} ${this.month_year}`;
  
  // Aggregate all table sections if multiple exist
  const tableContent = this.buildPrintTableContent(12);

  // Also include the footer totals if available
  const totalsHtml = this.payrollTotals?.nativeElement?.innerHTML || '';

  const popupWin = window.open('', '_blank', 'width=900,height=700');
  if (!popupWin) return;

  const printContents = `
    <html>
      <head>
        <title>Payroll Preview - ${monthYear}</title>
        <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700&display=swap" rel="stylesheet">
        <style>
          /* ✅ Base Reset & Print Quality */
          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          body {
            font-family: 'Outfit', Arial, sans-serif;
            margin: 0;
            padding: 0;
            color: #333;
            background: white !important;
          }

          .page {
            padding: 40px;
            max-width: 1000px;
            margin: 0 auto;
          }

          /* ✅ Simple Grid Fallback for row/col-X (Bootstrap) */
          .row {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
          }
          .col-3 { width: 25%; }
          .col-4 { width: 33.33%; }
          .col-5 { width: 41.66%; }
          .col-8 { width: 66.66%; }
          .col-9 { width: 75%; }
          .col-12 { width: 100%; }

          /* ✅ Header Styling */
          .bank-header {
            margin-bottom: 30px;
            padding-bottom: 20px;
            padding-top:80px;
          }
          .bank-header-p{
          font-weight: bold;
          }
          .bank-header p {
            margin: 0 0 5px 0;
            font-size: 14px;

          }
          .subject-line {
            font-size: 18px;
            text-align: center;
            margin: 25px 0;
            font-weight: 700;
          }

          /* ✅ Custom Table Structure Styling (Matching your UI) */
          .customertable-head-h1 {
            background-color: #03ad1a !important; /* Purple-ish header */
            border: 1px solid #E9E3FF;
            padding: 12px 15px;
            font-weight: 700;
            display: flex;
            align-items: center;
          }
          
          .customertable-head-h1 h1 {
            font-size: 13px !important;
            margin: 0;
            color: black !important;
            text-transform: uppercase;
          }

          .customertable-body-p {
            padding: 10px 15px;
            border-bottom: 1px solid #d6d3d3;
            border-left: 1px solid #d6d3d3;
            border-right: 1px solid #d6d3d3;
            display: flex;
            align-items: center;
            background-color: #F7F7F7 !important; 
          }
          
          .customertable-body-p p {
            font-size: 13px;
            margin: 0;
            color: #555;
          }

          .print-section {
            margin-bottom: 20px;
          }

          .table-head {
            background-color: #03ad1a !important;
            border: 1px solid #d6d3d3;
            border-bottom: none;
            padding: 10px 15px;
          }

          .table-head h1 {
            margin: 0;
            font-size: 14px;
            font-weight: 700;
            color: #000;
          }

          .customertable-footer {
            background-color: #03ad1a !important;
            padding: 10px 15px;
            border: 1px solid #eee;
            margin-top: -1px;
            display: flex;
            align-items: center;
          }
          
          .customertable-footer p, .customertable-footer h1 {
            font-size: 14px;
            margin: 0;
            font-weight: 700;
          }

          .footer-head-center {
            justify-content: flex-end;
            padding-right: 20px;
          }

          /* ✅ Totals Section Styling */
          .preview-payroll-total {
            margin-top: 30px;
            border: 1px solid #eee;
            border-radius: 8px;
            overflow: hidden;
            width: 350px;
            margin-left: auto;
          }
          
          .preview-payroll-total h1 {
            display: flex;
            justify-content: space-between;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
            border-bottom: 1px solid #eee;
          }
          
          .preview-payroll-total h1 span {
            font-weight: 700;
          }

          .net-total-salary {
            background-color: #088F9E !important;
            color: white !important;
            font-size: 16px !important;
          }
          
          .net-total-salary span {
            color: white !important;
          }

          /* ✅ Bank Footer */
          .bank-footer {
            margin-top: 50px;
            padding-top: 20px;
          }
          .bank-footer p {
            margin: 5px 0;
            font-size: 14px;
          }

          /* ✅ Print Adjustments */
          @page {
            margin: 15mm;
            size: A4;
          }
          
          @media print {
            .page { padding: 0; }
            tr { page-break-inside: avoid; }
            .print-page-break {
              page-break-after: always;
              break-after: page;
            }
            .print-page-break + .print-section {
              padding-top: 80px;
            }
          }
        </style>
      </head>

      <body>
        <div class="page">

          <!-- HEADER -->
          <div class="bank-header">
            <p class="bank-header-p">To,</p>
            <p class="bank-header-p">The Branch Manager,</p>
            <p class="bank-header-p">Meezan Bank, Lahore, Pakistan</p>

            <div class="subject-line">
              Sub: Salaries Transfer Request - ${monthYear}
            </div>

            <p class="bank-header-p">Dear Concern,</p>
            <p>
              We request you to kindly credit the salary of our staff to their accounts.
              The details of the staff and their accounts are mentioned below.
            </p>
          </div>

          <!-- TABLE CONTENT -->
          <div class="tables-container">
            ${tableContent}
          </div>

        

          <!-- FOOTER -->
          <div class="bank-footer">
            <p>Regards!</p>
            <p><strong>Hammad Ali</strong></p>
            <p>Kodex Technologies - Partner</p>
          </div>

        </div>

        <script>
          function triggerPrint() {
            window.focus();
            window.print();
            // Safari workaround: don't close immediately if printing, 
            // but for simple cases window.onafterprint can be used.
            window.onafterprint = () => window.close();
            // Fallback for some browsers
            setTimeout(() => {
              if (!window.closed) window.close();
            }, 1000);
          }

          // Ensure all images/fonts are loaded before printing
          window.onload = function () {
            setTimeout(triggerPrint, 500);
          };
        </script>
      </body>
    </html>
  `;

  popupWin.document.open();
  popupWin.document.write(printContents);
  popupWin.document.close();
}

}
